import {
    Paragraph
} from "docx";
import { tablineWithOneTab } from "../summary/tablines1";
import { paragraphArial, paragraphArialBold } from "./paragraphs";

export const gutachterFieldBrandenburg = user => {
  return [
    new Paragraph(""),
    paragraphArialBold(`Gutachter/in (${user?.firstName} ${user.lastName})`),
    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    new Paragraph(""),
    tablineWithOneTab("\t"),
    paragraphArial("Gutachter/in / Dienstbezeichung / Datum")
  ];
};
